<template>
	<div class="sf-input-group-wrapper">
		<span class="sf-input-group-wrapper__label">{{ label }}</span>
		<div class="search-option-wrapper__normal">
			<el-input
				v-model="data"
				@change="
					value => {
						return setSearchParam_({ key: this.paramKey, value: value });
					}
				"
				clearable
			></el-input>
		</div>
	</div>
</template>

<script>
import { serviceComputed, serviceMethods } from '@mqy/ceqi/CmpnMst/store/helpers';
export default {
	props: ['label', 'paramKey'],
	data() {
		return {
			data: null
		};
	},
	computed: {
		...serviceComputed
	},
	methods: {
		...serviceMethods,
		changeData() {
			this.$emit('change', this.inputData);
		}
	}
};
</script>

<style></style>
